import React, {Component} from 'react';
import {connect} from 'react-redux';
import {checkSession, getAppsListApi} from "../../api/api";
import {
  APP_LIST,
  APP_LIST_EXTENDED,
  GET_APPLICATION_LIST,
  GET_APPLICATION_LIST_SUBSCRIBED,
  MESSAGE_EVENT_TYPE
} from "../../constants/postMessages";
import {checkOrigin, getOrigin} from "../../actions/storage";

export class ListSAML extends Component {

  getAppsList = (e) => {
    if (checkOrigin(e.origin) && e.data === GET_APPLICATION_LIST) {
      getAppsListApi().then(response => {
        if (response.ok) {
          response.json().then(data => {
            window.parent.postMessage(JSON.stringify({
              type: APP_LIST,
              data: data.map(app => app.id)
            }), getOrigin());
            window.parent.postMessage(JSON.stringify({
              type: APP_LIST_EXTENDED,
              data: data.map(app => ({
                "id": app.id,
                "name": app.name,
                "userFriendlyName": app.userFriendlyName,
                "applicationType": app.applicationType
              }))
            }), getOrigin());
          })
        }
          }
      );
    }
  }

  componentDidMount() {
    if (checkSession(this.props.history)) {
      window.addEventListener(MESSAGE_EVENT_TYPE, this.getAppsList);
      window.parent.postMessage(GET_APPLICATION_LIST_SUBSCRIBED, getOrigin());
    }
  }

  componentWillUnmount() {
    window.removeEventListener(MESSAGE_EVENT_TYPE, this.getAppsList);
  }

  render() {
    return (<div/>);
  }
}

export default connect()(ListSAML);
